export enum ActiveUserActionTypes {
    SET_ACTIVE_USERS = "SET_ACTIVE_USERS",
    CLEAR_ACTIVE_USERS = "CLEAR_ACTIVE_USERS"
}